import { Observable } from 'rxjs';
import _ from 'lodash';
import { ActionsObservable } from 'redux-observable';

import DonationsApi from 'entities/donation/api';

import {
  FetchDonationsForPayrollAction,
  fetchDonationsForPayrollSuccessAction,
  fetchDonationsForPayrollErrorAction,
  FETCH_DONATIONS_FOR_PAYROLL,
} from './types';

const init = (action$: ActionsObservable<FetchDonationsForPayrollAction>) =>
  action$.ofType(FETCH_DONATIONS_FOR_PAYROLL).mergeMap(({ payrollRunId }) =>
    DonationsApi.fetch({ payrollRun: payrollRunId })
      .mergeMap((resultingActions) =>
        Observable.concat(
          Observable.of(fetchDonationsForPayrollSuccessAction(payrollRunId)),
          Observable.of(..._.flatten(resultingActions))
        )
      )
      .catch((e) => Observable.of(fetchDonationsForPayrollErrorAction(payrollRunId, e)))
  );

export default [init];
